module.exports = __webpack_public_path__ + "media/src/assets/icons/ico-loop-pc-9202001b1a4ed747a8484d5b73f8ee90.svg";